export default __webpack_public_path__ + "static/media/3435 utensils top.892c88dd.png";